<ng-container [formGroup]="form">
  @if (form && question != null && question.visible) {
    <div [ngClass]="getDivClass(question)" id="{{question.key}}_ques" >
      <label [ngClass]="!question.required ? '': 'required'">{{question.label}}</label>
      <div>
        @switch (question.controlType) {
          @case ('textentry') {
            <textentry-question  [disabled_]="disabled_field" [ngClass]="{ 'is-invalid': !isValid}" [formControlName]="question.key" [question]="question" (change)="valueChange($event,question)"></textentry-question>
          }
          <!-- <select [id]="question.key" *ngSwitchCase="'dropdown'" [formControlName]="question.key">
          <option *ngFor="let opt of question.options" [value]="opt.key">{{opt.value}}</option>
        </select> -->
        @case ('singleChoice') {
          <single-choice-question   [ngClass]="{ 'is-invalid': !isValid}" [formControlName]="question.key" [question]="question" (change)="valueChange($event,question)"></single-choice-question>
        }
      }
    </div>
    <!-- <div class="errorMessage" *ngIf="!isValid">{{question.label}} is required</div> -->
    @if (!isValid) {
      <span class="input-error-msg">{{'field.label.Invalid_Input' | translate | async }}</span>
    }
  </div>
}
</ng-container>
